import { Card, Divider } from "antd";

const Explore=()=>{

    return(
        <div className="explore">
<div className="header-text">Explore</div>
<div className="explore-content">
<Card
      style={{
        width: 402,
        height: 196,
        padding: 0,
        backgroundImage: "url('/Home/newBg.svg')", // your background SVG
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: 16,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      bodyStyle={{ padding: 0 }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src="/Home/new.svg"
          alt="icon"
          style={{ width: 48, height: 48 }}
        />
        <p style={{ marginTop: 8, color: "#fff", fontSize: 16, fontWeight: 500 }}>
          New to FoodLuv
        </p>
      </div>
    </Card>

    <Card
      style={{
        width: 402,
        height: 196,
        padding: 0,
        backgroundImage: "url('/Home/fastestBg.svg')", // your background SVG
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: 16,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      bodyStyle={{ padding: 0 }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src="/Home/fastest.svg"
          alt="icon"
          style={{ width: 48, height: 48 }}
        />
        <p style={{ marginTop: 8, color: "#fff", fontSize: 16, fontWeight: 500 }}>
          Fastest Delivery
        </p>
      </div>
    </Card>

    <Card
      style={{
        width: 402,
        height: 196,
        padding: 0,
        backgroundImage: "url('/Home/offersBg.svg')", // your background SVG
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: 16,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      bodyStyle={{ padding: 0 }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src="/Home/offers.svg"
          alt="icon"
          style={{ width: 48, height: 48 }}
        />
        <p style={{ marginTop: 8, color: "#fff", fontSize: 16, fontWeight: 500 }}>
          Offers you can't resist
        </p>
      </div>
    </Card>

    </div>
        </div>
    )
}
export default Explore;